/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React, { memo } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { Helmet } from "react-helmet";
import { Switch, Route } from "react-router-dom";

import { useInjectSaga } from "utils/injectSaga";
import { useInjectReducer } from "utils/injectReducer";
import reducer from "./reducer";
import saga from "./saga";

import { flushState } from "./actions";
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectLocation,
} from "./selectors";

// utils
import useDeviceDetect from "utils/useDeviceDetect";

// ant styles
import "antd/dist/antd.less";
//import 'antd-mobile/dist/antd-mobile.less';
// import 'antd/dist/antd.css'
//import 'ant-design-pro/dist/ant-design-pro.css';

// app styles
import "./style.scss";

// capacitor
import AppListener from "appCapacitor/AppListener";
import { appHelper } from "appCapacitor/helpers";

// components
import ScrollToTop from "components/ScrollToTop";

// engine
import MainLayout from "engine/MainLayout";
import MobileLayout from "engine/MobileLayout";
import AuthRoute from "engine/AuthRoute";

// layouts
import AccessDenied from "layouts/AccessDenied";

// pages
import ResetPassword from "pages/ResetPassword";
import ConfirmProfile from "pages/ConfirmProfile";
import Login from "pages/Login";
import SignupParent from "mobile/pages/SignupParent";

function App({ history }) {
  useInjectReducer({ key: "appSaga", reducer });
  useInjectSaga({ key: "appSaga", saga });

  const { isMobile } = useDeviceDetect();

  let width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  let isApp = false;
  if (!appHelper.isWeb || isMobile || width < 800) {
    isApp = true;
  }

  return (
    <>
      {isApp && <AppListener />}

      <Helmet titleTemplate="%s - Schoolinked" defaultTitle="Schoolinked">
        <meta name="description" content="Schoolinked" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Schoolinked - Education" />
        <meta
          property="og:description"
          content="Schoolinked is a new unique platform aimed at encouraging and stimulating knowledge sharing and other forms of learning opportunities."
        />
        <meta property="og:image" content="" />
      </Helmet>

      <ScrollToTop />

      <div id="top">
        <Switch>
          <Route path={["/oauth", "/login"]} component={Login} />
          <Route path={["/reset"]} component={ResetPassword} />
          <Route path={["/activation"]} component={ResetPassword} />
          <Route path={["/confirm"]} component={ConfirmProfile} />
          <Route path={["/404"]} component={AccessDenied} exact />
          <AuthRoute
            path={["/signupparent"]}
            component={SignupParent}
            roles={["parent"]}
          />
          <AuthRoute
            path="/"
            component={!isApp ? MainLayout : MobileLayout}
            roles={["admin", "teacher", "parent"]}
          />
        </Switch>
      </div>
    </>
  );
}

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  error: makeSelectError(),
  location: makeSelectLocation(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushState()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(App);
